module.exports = __webpack_public_path__ + "img/investment.4c768d48.svg";